import { Container } from "unstated";

import _ from "lodash";

import { differenceInMilliseconds } from "date-fns";

class LoadingContainer extends Container {
  constructor(serviceContainer, props = {}) {
    super(props);

    this.serviceContainer = serviceContainer;

    this.state = {
      loading: {}
    };
  }

  setLoading(keyName) {
    this.setState((state) =>
      _.tap(state, (state) => {
        state.loading[keyName] = new Date();
      })
    );
  }

  setLoaded(keyName) {
    this.setState((state) =>
      _.tap(state, (state) => {
        _.unset(state.loading, keyName);
      })
    );
  }

  isLoading(keyName) {
    return _.has(this.state.loading, keyName);
  }

  getDuration(keyName) {
    return this.isLoading(keyName)
      ? differenceInMilliseconds(this.state.loading[keyName], new Date())
      : 0;
  }
}

export { LoadingContainer };
